import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DurationIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DurationGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.1804 21.9995C6.66596 21.9995 2.17993 17.5135 2.17993 11.9995C2.17993 6.48555 6.66596 1.99951 12.1804 1.99951C17.6944 1.99951 22.1804 6.48554 22.1804 11.9995C22.1804 17.5135 17.6944 21.9995 12.1804 21.9995ZM12.1804 3.00536C7.22094 3.00536 3.18578 7.04003 3.18578 11.9995C3.18578 16.959 7.22094 20.9937 12.1804 20.9937C17.1399 20.9937 21.1746 16.959 21.1746 11.9995C21.1746 7.04003 17.1399 3.00536 12.1804 3.00536Z"
        fill="#696969"
      />
      <path
        d="M15.5726 15.6683C15.4498 15.6683 15.3265 15.6236 15.2293 15.5332L11.837 12.3674C11.7353 12.2721 11.6774 12.139 11.6774 11.9995V5.94333C11.6774 5.66534 11.9023 5.4404 12.1803 5.4404C12.4583 5.4404 12.6832 5.66534 12.6832 5.94333V11.781L15.9159 14.7975C16.1187 14.9871 16.1295 15.3053 15.9404 15.5087C15.8412 15.6147 15.7071 15.6683 15.5726 15.6683Z"
        fill="#696969"
      />
    </svg>
  );
};

export default DurationIcon;
